module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builds-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.buildList), function(b) {
    return _c('div', {
      key: b.buildId,
      staticClass: "build",
      class: 'build-' + _vm.getBuildClass(b.status)
    }, [_c('div', {
      staticClass: "build-icon"
    }, [(b.status === 1) ? _c('i', {
      staticClass: "fas fa-clock"
    }) : (b.status === 2) ? _c('i', {
      staticClass: "fas fa-cog fa-spin"
    }) : (b.status === 3) ? _c('i', {
      staticClass: "fas fa-check-circle"
    }) : (b.status === 4) ? _c('i', {
      staticClass: "fas fa-ban"
    }) : (b.status === 5) ? _c('i', {
      staticClass: "fas fa-exclamation-triangle"
    }) : _c('i', {
      staticClass: "fas fa-question-circle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(b.description))]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('i', {
      staticClass: "fas fa-code-branch fa-lg fa-fw"
    }), _vm._v("\n\t\t\t" + _vm._s(b.sourceBranch) + "\n\t\t\t-\n\t\t\t" + _vm._s(b.dateString) + "\n\t\t")])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Build Pipeline")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-520141a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/dev-builds.vue
// module id = 571
// module chunks = 0